export class RevokeResourcePermissionError extends Error {
}